import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";
import { ActionCreator } from "typescript-fsa";

import { Api } from "@api/index";
import { ApiButton } from "@api/components/ApiButton";
import { connectToApi, ApiConnectedOwnProps } from "@api/components/connectToApi";
import { DspsState } from "@dsps/models";
import { MusicState } from "@music/models";
import { messages } from "../../messages";
import { Delivery, DeliveryState, Filters } from "../../models";
import { getDeliveriesList, hasMorePages, getNextPage, getFilters } from "../../selectors";
import { setFilters, resetFilters } from "../../actions";
import { DeliveriesFilters } from "../DeliveriesFilters";
import { DeliveriesTable } from "../DeliveriesTable";

type State = DeliveryState & MusicState & DspsState;

interface DeliveriesListStateProps extends ApiConnectedOwnProps {
    deliveries: Delivery[];
    morePages: boolean;
    nextPage: number;
    filters: Filters;
}

interface DeliveriesListDispatchProps {
    setFilters: ActionCreator<Filters>;
    resetFilters: ActionCreator<{}>;
}

type Props = DeliveriesListStateProps & DeliveriesListDispatchProps;

class DeliveriesList extends React.Component<Props> {
    private loadMore() {
        const { nextPage, filters } = this.props;
        return Api.deliveriesIndex(nextPage, filters);
    }

    private updateFilters(filters: Filters) {
        this.props.setFilters(filters);
    }

    public render() {
        const { deliveries, morePages, filters } = this.props;
        const actionCreator = (f: Filters) => Api.deliveriesIndex(1, f);
        return (
            <div className="deliveries-list">
                <DeliveriesFilters
                    filters={filters}
                    actionCreator={actionCreator}
                    onFilter={(f: Filters) => this.updateFilters(f)}
                />
                <DeliveriesTable deliveries={deliveries} />
                {morePages &&
                    <div className="deliveries-list__load-more">
                        <ApiButton actionCreators={[() => this.loadMore()]}>
                            <FormattedMessage {...messages.loadMoreDeliveries} />
                        </ApiButton>
                    </div>
                }
            </div>
        );
    }
}

const makeDeliveriesActionCreator = (filters: Filters) => () => Api.deliveriesIndex(1, filters);

const mapStateToProps = (state: State): DeliveriesListStateProps => {
    const filters = getFilters(state);
    return {
        deliveries: getDeliveriesList(state),
        morePages: hasMorePages(state),
        nextPage: getNextPage(state),
        filters,
        actionCreators: [ Api.dspsIndex, makeDeliveriesActionCreator(filters) ],
    };
};

const mapDispatchToProps = (dispatch: Dispatch<State>): DeliveriesListDispatchProps => {
    return {
        setFilters: bindActionCreators(setFilters, dispatch),
        resetFilters: bindActionCreators(resetFilters, dispatch),
    };
};

const ConnectedDeliveriesList = compose(
    connect(mapStateToProps, mapDispatchToProps),
    connectToApi({}),
)(DeliveriesList);

export {
    DeliveriesList as DeliveriesListPresenter,
    ConnectedDeliveriesList as DeliveriesList,
    Props as DeliveriesListProps,
    DeliveriesListStateProps,
};
